/* eslint-disable */
import { useEffect, useState } from 'react'
import MFIndividualInvestmentsTable from '../../Components/MutualFunds/MFIndividualInvestmentsTable'
import { useRecoilValueLoadable } from 'recoil'
import { FabitsStarFunds, MutualFundsHolding } from '../../store/MFStore'
import MFInvestmentSkeleton from '../../Components/SkeletonLoaders/MFInvestmentSkeleton'
import env from '../../env/env'
import { Card, CardContent, CardHeader, CardTitle } from '../../Components/ui/card'

const MFIndividualInvestments = () => {
  const mfHolding = useRecoilValueLoadable(MutualFundsHolding)
  const fabStarFunds = useRecoilValueLoadable(FabitsStarFunds)

  const [invidualHoldings, setInvidualHoldings] = useState({})

  const groupByISIN = (holdings = []) => {
    const grouped = {}

    holdings.forEach((item) => {
      const isin = item?.isincd
      if (!isin) return

      if (!grouped[isin]) {
        grouped[isin] = { ...item }
      } else {
        grouped[isin] = {
          ...grouped[isin],
          balance: (grouped[isin].balance || 0) + (item.balance || 0),
          netInvestedAmt: (grouped[isin].netInvestedAmt || 0) + (item.netInvestedAmt || 0),
          holding: (grouped[isin].holding || 0) + (item.holding || 0),
        }
      }
    })

    return Object.values(grouped)
  }

  useEffect(() => {
    if (mfHolding?.state === 'hasValue') {
      const filteredHoldings =
        mfHolding?.contents?.mainData?.filter(
          (item) => item?.isOutsideData === 0 && Number(item?.balance) > 0 && item?.isincd,
        ) || []

      const groupedHoldings = groupByISIN(filteredHoldings)

      setInvidualHoldings({ mainData: groupedHoldings })
    } else if (mfHolding?.state === 'hasError') {
      console.error('Error fetching MF holdings:', mfHolding.contents)
    }
  }, [mfHolding])

  switch (mfHolding.state) {
    case 'loading':
      return <MFInvestmentSkeleton />

    case 'hasValue':
      return (
        <>
          {mfHolding.state === 'hasValue' && (
            <MFIndividualInvestmentsTable
              holdings={
                invidualHoldings?.mainData ? invidualHoldings : mfHolding.contents?.mainData
              }
              fabStarFunds={fabStarFunds}
            />
          )}
        </>
      )

    case 'hasError':
      return (
        <div className='bg-white flex items-center justify-center'>
          <Card className='w-full max-w-3xl text-center border-none shadow-none font-DMSans'>
            <CardHeader className='flex flex-col gap-y-6 justify-center items-center'>
              <img className='h-14 w-14' src={`${env.SVGS}/error-icon.svg`} alt='Error-Icon' />
              <CardTitle className='font-semibold text-base'>Oops! Something Went Wrong</CardTitle>
            </CardHeader>
            <CardContent className='flex flex-col gap-y-6'>
              <p className='text-sm leading-5 text-black-400 mb-6'>
                We're sorry, but it seems there was an issue connecting to our server. Please check
                your internet connection or try refreshing the page. If the problem persists, try
                again later.
              </p>

              {/* <div className='flex gap-x-2 justify-between'>
                <Button
                  className='w-full'
                  variant='fabitsWhite'
                  onClick={() => window.location.reload()}
                >
                  <Refresh className='mr-2 h-4 w-4 text-black-300' /> Refresh
                </Button>

                <Link className='flex-1' to='/dashboard/mutual-funds'>
                  <Button className='w-full'>
                    View Funds
                    <MoveRight className='ml-2 h-4 w-4' />
                  </Button>
                </Link>
              </div> */}
            </CardContent>
          </Card>
        </div>
      )

    default:
      return null
  }
}

export default MFIndividualInvestments
